export default "__VITE_ASSET__BgvhIXTB__"